<script lang="ts">
    // import SyncTest from '@shared/components/syncTest.vue'
    import { computed, inject, onMounted, reactive, ref } from 'vue';
    import vm /*, { getLocalStorageItem, removeLocalStorageItem, setLocalStorageItem }*/ from '../Journeys.viewmodel';
    // utils
    import { tmp_uuidv4 /*, UngappedJourney*/ } from '../Journeys.viewmodel';

    import { $Resources, api } from '@cwd/lib/main';
    import { cancelFrame, requestFrame, uid } from '@cwd/shared/utils';
    // import { listingsProcessor_reduce } from '@shared/utils/ListingsController'
    // import { vue_ko_sync } from '@cwd/shared/KoSync'
    import BSDropdownButton from '@shared/components/BSDropdownButton.vue';
    import List from '@shared/components/List.vue';
    import { useRouter } from 'vue-router';
    import JourneyListItem, { type Journey } from '../components/JourneyListItem.vue';

    // const toHumanTime = new HumanTime({ locale: 'sv' })

    interface JourneysTabData {
        list: { [key: string]: unknown | any };
        heading: string;
        intro: string;
        notification: string;
    }

    const component = {
        name: 'Page_JourneyStart',
    };

    export default {
        name: component.name,
    };

    export const journeysOrderOptions = () => {
        return [
            {
                key: 'LastModified',
                display: $Resources.LastModifiedLabel,
            },
            {
                key: 'Title',
                display: $Resources.TitleLabel,
            },
            {
                key: 'Description',
                display: $Resources.DescriptionLabel,
            },
        ];
    };
</script>

<script lang="ts" setup>
    import { type TagsProvide } from '@shared/components/Tags/Tags.access';
    import { GetIssueSchedule, MoveToSent, SaveIssueSchedule } from '@journeys/Journey.access';
    import { bsAlert } from '@shared/components/BsAlerts';
    import Modal from '@shared/components/Modal.vue';
    import { type Issue } from '@journeys/components/JourneyListItem.vue';

    const tags = inject('tags') as TagsProvide;
    const router = useRouter();

    // const cid = uid();
    const { editor, /* activeJourney, */ startMenu, nav /*, account */ } = vm;

    onMounted(async () => {
        switchTab(router.currentRoute.value.path.replace('/', ''));

        editor.events.reset();
        nav.x = 0;
        nav.y = 0;
        nav.z = 0;
    });

    const journeysTabs = {
        drafts: { name: 'drafts', display: $Resources.JourneysDraftsTabLabel },
        active: { name: 'active', display: $Resources.JourneysActiveTabLabel },
        ended: { name: 'ended', display: $Resources.JourneysEndedTabLabel },
        templates: { name: 'templates', display: $Resources.JourneysTemplatesTabLabel },
    };

    const currentTab = ref('drafts'),
        tabData: JourneysTabData = reactive({
            list: {},
            heading: $Resources.JourneysDraftsHeading,
            intro: $Resources.JourneysDraftsIntroduction,
            notification: $Resources.JourneysNoDraftsLabel,
        }),
        filteredList = computed(() => {
            let res = Object.values(tabData.list);
            return res as Journey[];
        });

    const setTabData = (journeys: Journey[]) => {
        journeys.forEach((journey) => {
            journey.data = JSON.parse(journey.GraphicalData);

            journey.data.Tags = journey.Tags;

            tabData.list[journey.JourneyId] = journey;
        });
    };

    let newJourneyWindow = ref(false);

    const fetchListings = async (status: string) => {
        editor.state.busy = true;
        tabData.list = {};

        api.get(`/journeys/${status}`)
            .then((data: Journey[]) => {
                setTabData(data);
            })
            .finally(() => {
                editor.state.busy = false;
            });

        router.push('/Journeys/' + status);
    };

    const switchTab = async (rawTab: string) => {
        const tab = rawTab.toLowerCase().replace('journeys/', '');
        newJourneyWindow.value = false;
        clearSelection();

        switch (tab) {
            case 'drafts':
                await fetchListings(tab);

                tabData.heading = $Resources.JourneysDraftsHeading;
                tabData.intro = $Resources.JourneysDraftsIntroduction;
                tabData.notification = $Resources.JourneysNoDraftsLabel;
                break;
            case 'active':
                await fetchListings(tab);

                tabData.heading = $Resources.JourneysActiveHeading;
                tabData.intro = $Resources.JourneysActiveIntroduction;
                tabData.notification = $Resources.JourneysNoActiveLabel;
                break;
            case 'ended':
                await fetchListings(tab);

                tabData.heading = $Resources.JourneysEndedHeading;
                tabData.intro = $Resources.JourneysEndedIntroduction;
                tabData.notification = $Resources.JourneysNoEndedLabel;
                break;
            case 'templates':
                await fetchListings(tab);

                tabData.heading = $Resources.JourneysTemplatesHeading;
                tabData.intro = $Resources.JourneysTemplatesIntroduction;
                tabData.notification = $Resources.JourneysNoTemplatesLabel;
                break;
            default:
        }

        currentTab.value = tab.toLowerCase().replace('journeys/', '');
    };

    let observerFrame = 0;

    const handleResizeChanges = (val: any) => {
        val.forEach((v: any) => {
            cancelFrame(observerFrame);
            observerFrame = requestFrame(() => {
                let el = v.target;
                let obj = resizeObserver[el.dataset.key],
                    { name, value } = obj;

                let res = v.contentRect[name] / value;
                obj.ref.value = res;
            });
        });
    };

    const resizeObserver: any = {
        observer: {},
        callback: handleResizeChanges,
    };

    const deleteSelectedItems = () => {
        let journeys = startMenu.selected.map((id) => {
            return { JourneyId: id };
        });

        api.delete(`/journeys`, journeys).then(() => {
            for (let { JourneyId } of journeys) {
                delete tabData.list[JourneyId!];
            }

            clearSelection();
        });
    };

    const clearSelection = () => {
        startMenu.selected = [];
    };

    const cleanJourney = () => {
        router.push('/Journeys/' + tmp_uuidv4() + '?clean=true');
    };

    const openTemplates = () => {
        router.push('/Journeys' + '/new');
    };

    const openJourney = (journey: any) => {
        journey.data.JourneyId = journey.JourneyId;
        Object.assign(vm.activeJourney, journey.data);

        router.push('/Journeys/' + journey.data.JourneyId);
    };

    const modalOpen = ref(false);
    const abortedIssues = ref([] as { subject: string; issueId: string }[]);
    const journeyIssues = ref<Issue[]>([]);
    const reactivating = ref(false);

    function handleOpenModal(issues: Issue[]) {
        console.log(issues);

        journeyIssues.value = issues;
        abortedIssues.value = issues.filter((i) => i.Status === 60)?.map((i) => ({ subject: i.Subject ?? i.Title, issueId: i.IssueId })) ?? [];
        modalOpen.value = true;
    }

    async function handleReActivateIssue(issueId: string) {
        if (reactivating.value) return;
        reactivating.value = true;

        const currentSchedule = await GetIssueSchedule(issueId);

        if (currentSchedule.length === 0) {
            bsAlert({
                title: $Resources.ErrorReactivatingNoSchedule,
                content: $Resources.ErrorLabel,
                type: 'danger',
            });
            reactivating.value = false;
            return;
        }

        if (currentSchedule?.length > 1) {
            bsAlert({
                title: $Resources.ErrorReactivatingMultipleSchedules,
                content: $Resources.ErrorLabel,
                type: 'danger',
            });
            reactivating.value = false;
            return;
        }

        await MoveToSent(issueId);
        await SaveIssueSchedule(issueId, { ...currentSchedule[0], TaskStatus: 'Scheduled' });

        bsAlert({
            title: $Resources.GeneralSuccessAlertHeading,
            content: $Resources.SuccesReactivatingIssueContent,
            type: 'success',
        });

        abortedIssues.value = abortedIssues.value.filter((i) => i.issueId !== issueId);
        journeyIssues.value = journeyIssues.value.map((i) => (i.IssueId === issueId ? { ...i, Status: 70 } : i));
        console.log('tabData.list', tabData.list);
        let res = Object.values(tabData.list);
        const journeyId = res.find((j) => j.Issues.find((i) => i.IssueId === issueId)).JourneyId;
        tabData.list[journeyId].Issues = tabData.list[journeyId].Issues.map((i: Issue) => (i.IssueId === issueId ? { ...i, Status: 70 } : i));

        if (abortedIssues.value.length === 0) {
            modalOpen.value = false;
        }

        reactivating.value = false;
    }
</script>

<template>
    <List
        itemId="JourneyId"
        :title="$Resources.JourneysHeader"
        :description="tabData.intro"
        :items="filteredList"
        :loading="editor.state.busy"
        :filterKeys="['Title', 'Description']"
        :orderOptions="journeysOrderOptions()"
        :checkedItems="startMenu.selected"
        displayAs="cards"
        :displayOptions="['default', 'cards']"
        :tabs="journeysTabs"
        :currentTab="currentTab"
        :disableCheckboxes="currentTab === 'active'"
        :tags="tags"
        @update:tab="(newVal: string) => switchTab(newVal)"
        @update:checkedItems="(newVal: string[]) => (startMenu.selected = newVal)"
        @clearSelected="clearSelection"
        @deleteSelected="deleteSelectedItems">
        <template #toolbar>
            <BSDropdownButton menuClass="dropdown-menu-right" v-show="startMenu.selected.length === 0">
                <template #toggle>
                    <span class="glyphicon glyphicon-plus m-xxs-r"></span>
                    {{ $Resources.NewJourneyBtn }}
                </template>
                <template #content>
                    <li role="presentation" class="dropdown-header">{{ $Resources.NewJourneyBtn }}:</li>
                    <li>
                        <a href="javascript:void(0)" :class="editor.state.busy && 'pe-none'" @click="cleanJourney">
                            {{ $Resources.JourneysNewDraftBtnLabel }}
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" :class="editor.state.busy && 'pe-none'" @click="openTemplates">
                            {{ $Resources.JourneysNewDraftFromTemplateBtnLabel }}
                        </a>
                    </li>
                </template>
            </BSDropdownButton>
        </template>
        <template #item="{ item, index }">
            <JourneyListItem
                :currentTab="currentTab"
                :journey="item"
                :index="index"
                :tags="tags"
                @journeyClicked="openJourney(item)"
                @reactivateAbortedIssuesClicked="(newVal: any) => handleOpenModal(newVal)"></JourneyListItem>
        </template>
    </List>

    <Modal :title="$Resources.JourneyHasAbortedIssuesTitle" :show="modalOpen" @close="modalOpen = false">
        <template #content>
            <table class="table table-hover">
                <tbody class="td-align-middle">
                    <tr v-for="issue in abortedIssues" :key="issue.issueId">
                        <td>{{ issue.subject }}</td>
                        <td class="text-right">
                            <button class="btn btn-default btn-sm" :disable="reactivating" type="button" @click="handleReActivateIssue(issue.issueId)">
                                {{ $Resources.JourneyAbortedIssueReActivateBtn }}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
    </Modal>
</template>

<style lang="less"></style>
